import React from 'react'
import type { ReactElement, ReactNode } from 'react'
import type { GridProps } from '@vtex/admin-ui'
import { Grid, csx, cx } from '@vtex/admin-ui'

import { Icon } from '../../../../../../ui/components/Icon'

export type MethodSelectItemProps = {
  title: string
  icon: SpriteSymbol | ReactElement
  middleColumn: ReactNode
  rightColumn: ReactNode
  selected: boolean
} & GridProps

// TODO: use ui/components/DrawerSelectionItem
export const MethodSelectItem = ({
  title,
  icon,
  middleColumn,
  rightColumn,
  selected,
  className = '',
  ...props
}: MethodSelectItemProps) => {
  return (
    <Grid
      gap="1rem"
      templateColumns="auto 1fr"
      className={cx(
        csx({
          padding: '$space-4',
          border: selected ? '$mainSelected' : '$form.neutral',
          borderRadius: '0.3rem',
          background: selected ? '$secondary' : '$white',
          cursor: 'pointer',
          ':hover': {
            border: selected ? '$mainSelected' : '$form.neutralHover',
          },
        }),
        className
      )}
      {...props}
    >
      <Icon
        className={csx({
          marginTop: '$space-1',
          marginRight: '$space-3',
          width: '$space-5',
          height: '$space-5',
        })}
      >
        {icon}
      </Icon>
      <div className={csx({ minWidth: 0 })}>
        <div
          className={csx({
            display: 'flex',
            justifyContent: 'space-between',
          })}
        >
          <p
            className={csx({
              fontSize: '1rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: selected ? '$blue40' : '$primary',
            })}
          >
            {title}
          </p>
          <div className={csx({ marginLeft: '$space-2' })}>{rightColumn}</div>
        </div>
        {middleColumn}
      </div>
    </Grid>
  )
}
